import CommonValueObjectsFactory from '../../common/ValueObjects/factory.js'
import GigyaEventToPageNameAuthenticationMapper from './GigyaEventToPageNameAuthenticationMapper.js'
import HttpResponseToSessionAuthenticationMapper from './HttpResponseToSessionAuthenticationMapper.js'

export default class AuthenticationMappersFactory {
  static gigyaEventToPageNameAuthenticationMapper = ({config}) => new GigyaEventToPageNameAuthenticationMapper()

  static httpResponseToSessionAuthenticationMapper = ({config}) =>
    new HttpResponseToSessionAuthenticationMapper({
      userDataCommonFactory: CommonValueObjectsFactory.userDataCommonValueObject,
      logUserCommonFactory: CommonValueObjectsFactory.logUserCommonValueObject,
      loginCookieExpirationDate: config.get('login').LOGIN_COOKIE_EXPIRATION_TIME_IN_DAYS
    })
}
